var SIRV_SPIN_BASE = 'https://samsgroup.sirv.com/products/';

function getSirvSpinUrl(sku) {
  return SIRV_SPIN_BASE + encodeURIComponent(sku) + '/' + encodeURIComponent(sku) + '.spin';
}

function validateSirvSpin() {
  var $primary = jQuery('.product__primary');
  if (!$primary.length) {
    return;
  }

  var sku = $primary.attr('sku');
  var $spinSlides = jQuery('.product__media-item[data-slide-id="spin"]');

  if (!sku || !$spinSlides.length) {
    $spinSlides.remove();
    return;
  }

  var spinUrl = getSirvSpinUrl(sku);

  jQuery.ajax({
    url: spinUrl,
    type: 'HEAD',
    cache: true,
    timeout: 8000,
    success: function () {
      $spinSlides.removeClass('spin-slide--pending');
    },
    error: function () {
      $spinSlides.remove();
    }
  });
}

// Diamond certificate: Sirv first, then the PIM server. Ignores metafields.
var CERT_SOURCES = [
  'https://samsgroup.sirv.com/pdf/',
  'https://samsgroup.info/pim-images/'
];
var certCheckId = 0;

function certUrlExists(url) {
  return fetch(url, { method: 'HEAD', mode: 'cors' })
    .then(function (res) { return res.ok; })
    .catch(function () { return false; });
}

function findCertUrl(sku, index) {
  index = index || 0;
  if (!sku || index >= CERT_SOURCES.length) {
    return Promise.resolve(null);
  }
  var url = CERT_SOURCES[index] + encodeURIComponent(sku) + '.pdf';
  return certUrlExists(url).then(function (exists) {
    return exists ? url : findCertUrl(sku, index + 1);
  });
}

function updateProductCertificates(sku) {
  var blocks = document.querySelectorAll('[data-pk-cert]');
  if (!blocks.length) {
    return;
  }
  var checkId = ++certCheckId;
  var alsoLabels = document.querySelectorAll('.pk-cert-also');

  blocks.forEach(function (block) {
    if (sku !== undefined) {
      block.setAttribute('data-sku', sku || '');
    }
  });
  var currentSku = blocks[0].getAttribute('data-sku');

  findCertUrl(currentSku).then(function (url) {
    if (checkId !== certCheckId) {
      return;
    }
    blocks.forEach(function (block) {
      block.querySelectorAll('[data-pk-cert-link]').forEach(function (link) {
        link.href = url || '#';
      });
      block.hidden = !url;
    });
    alsoLabels.forEach(function (label) {
      label.hidden = !url;
    });
  });
}

function initProductCertificates() {
  if (!document.querySelector('[data-pk-cert]')) {
    return;
  }
  updateProductCertificates();
  document.addEventListener('product:variant-change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (variant) {
      updateProductCertificates(variant.sku);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductCertificates);
} else {
  initProductCertificates();
}

function removepopup() {
    $('.overlay').animate({'opacity':'0'}, 300, 'linear', function(){
        $('.overlay').css('display', 'none');
    });
    $('.popupform').fadeOut().css('display', 'none');
    $('#main').css('z-index',0);
}
jQuery(document).ready(function ($) {

  if ($('body[type="product"]').length > 0) {
    validateSirvSpin();
    document.addEventListener('product:variant-change', function () {
      setTimeout(validateSirvSpin, 600);
    });
  }


    if($('.product__primary').length >0){

        if(window.innerWidth < 919){
            setTimeout(function(){
                $('.product__media').css('min-height', window.innerWidth);
              }, 2000);
            
        }

    

    }
  if($('.ring-size-container').length >0){
    $('.ring-size-container').insertAfter($('.product-form__quantity'));
  }
    //ring size
    $('.ring-size input[type="radio"]').click(function(){
        $('.ring-size-btn').text($(this).attr('value'));
  removepopup();
  $('.ring-size-container .error-msg').hide();
});
$('.product-form button[type="submit"]').click(function() {

  if($('.ring-size-btn').text()=="Select a Ring Size"){ $('.ring-size-container .error-msg').show(); $('.raido-btn-container').css('border', 'solid 1px red'); return false;}
  else{   $('.raido-btn-container .error-msg').hide(); $('.raido-btn-container').css('border', 'solid 1px #000'); return true;}
  $('.raido-btn-container').css('border', 'solid 1px #000');
});  


      $('.popup-btn').click(function(){
          var formname = $(this).attr('popup');
          $('#main').css('z-index',510);
          $('.overlay').animate({'opacity':'.50'}, 300, 'linear').css('display', 'block');
          $('.'+formname).fadeIn();
          console.log('popshow'+formname);
      });
    $('body').on('click', '.overlay', function(){removepopup()});
    $('body').on('click', '.cancel-btn', function(){removepopup()});
});
